import {
  Directive,
  ElementRef,
  Input,
  NgZone,
  Optional,
  Renderer2,
  Self,
} from '@angular/core';
import {
  LayoutGapDirective as FlexLayoutLayoutGapDirective,
  MediaMonitor,
} from '@angular/flex-layout';
import { LayoutDirective } from './layout.directive';

type GapSize =
  | 'xxxsmall'
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'mid'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';

function convertGapSize(size: GapSize) {
  switch (size) {
    case 'xxxsmall':
      return '4px';
    case 'xxsmall':
      return '8px';
    case 'xsmall':
      return '12px';
    case 'small':
      return '16px';
    case 'mid':
      return '24px';
    case 'large':
      return '32px';
    case 'xlarge':
      return '48px';
    case 'xxlarge':
      return '64px';
    case 'xxxlarge':
      return '72px';
    case 'xxxxlarge':
      return '96px';
    default:
      return '0';
  }
}

@Directive({
  selector: `
    [flLayoutGap],
    [flLayoutGap.mobile],
    [flLayoutGap.tablet],
    [flLayoutGap.desktop-small],
    [flLayoutGap.desktop-large],
    [flLayoutGap.desktop-xlarge],
    [flLayoutGap.desktop-xxlarge],
  `,
})
export class LayoutGapDirective extends FlexLayoutLayoutGapDirective {
  constructor(
    monitor: MediaMonitor,
    elementRef: ElementRef,
    renderer: Renderer2,
    @Optional()
    @Self()
    container: LayoutDirective,
    zone: NgZone,
  ) {
    super(monitor, elementRef, renderer, container, zone);
  }

  @Input('flLayoutGap')
  set layoutGap(val: GapSize) {
    const pixelValue = convertGapSize(val);
    this._cacheInput('gap', pixelValue);
  }
  @Input('flLayoutGap.mobile')
  set layoutGapMobile(val: GapSize) {
    const pixelValue = convertGapSize(val);
    this._cacheInput('gapMobile', pixelValue);
  }
  @Input('flLayoutGap.tablet')
  set layoutGapTablet(val: GapSize) {
    const pixelValue = convertGapSize(val);
    this._cacheInput('gapTablet', pixelValue);
  }
  @Input('flLayoutGap.desktop-small')
  set layoutGapDesktopSmall(val: GapSize) {
    const pixelValue = convertGapSize(val);
    this._cacheInput('gapDesktopSmall', pixelValue);
  }
  @Input('flLayoutGap.desktop-large')
  set layoutGapDesktopLarge(val: GapSize) {
    const pixelValue = convertGapSize(val);
    this._cacheInput('gapDesktopLarge', pixelValue);
  }
  @Input('flLayoutGap.desktop-xlarge')
  set layoutGapDesktopXLarge(val: GapSize) {
    const pixelValue = convertGapSize(val);
    this._cacheInput('gapDesktopXLarge', pixelValue);
  }
  @Input('flLayoutGap.desktop-xxlarge')
  set layoutGapDesktopXXLarge(val: GapSize) {
    const pixelValue = convertGapSize(val);
    this._cacheInput('gapDesktopXXLarge', pixelValue);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/ui/layout/layout-gap.directive.ts